import SmoothScroll from "../components/SmoothScroll";
import Navbar from "../components/landing/Navbar";
import Act1Hero from "../components/landing/Act1Hero";
import Act2Conversation from "../components/landing/Act2Conversation";
import Act3Twist from "../components/landing/Act3Twist";
import Prueba from "../components/landing/Prueba";
import Act7Method from "../components/landing/Act7Method";
import SoyJordi from "../components/landing/SoyJordi";
import Act8Ultimatum from "../components/landing/Act8Ultimatum";
import Conversion from "../components/landing/Conversion";
import Footer from "../components/landing/Footer";
import CookieConsent from "../components/CookieConsent";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="bg-[#030303] text-white overflow-x-hidden">
        <Navbar />
        <main>
          <Act1Hero />          {/* I — Mensaje central de marca */}
          <Act2Conversation />  {/* T — El dolor */}
          <Act3Twist />         {/* F — El giro */}
          <Prueba />            {/* I+T — Resultado ↔ testimonio */}
          <Act7Method />        {/* Sistema — 4 capítulos */}
          <SoyJordi />          {/* I — Soy Jordi Betoret (autoridad + cercanía) */}
          <Act8Ultimatum />     {/* F — Dentro de un año + comunidad */}
          <Conversion />        {/* Reserva */}
        </main>
        <Footer />
        <CookieConsent />
      </div>
    </SmoothScroll>
  );
}
